import { documentationActions } from '../../actions/constant';

const { SUCCESS_GET_ALL_TEMPLATES, FAILURE_GET_ALL_TEMPLATES, REQUEST_GET_ALL_TEMPLATES } =
  documentationActions;

const intitialstate: object = {
  response: null,
  areGetTemplates: false,
  loading: false,
};

export const getAllTemplatesReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_TEMPLATES: {
      return {
        ...state,
        areGetTemplates: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case FAILURE_GET_ALL_TEMPLATES:
      return {
        ...state,
        areGetTemplates: false,
        response: action.payload,
        loading: false,
      };

    case REQUEST_GET_ALL_TEMPLATES:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
